<template>
  <div class="nye-page-container">


    <div class="page-content">
      <div class="row">
        <!-- Main Content Column -->
        <section class="col-lg-8 col-sm-12">
          <!-- Intro Section -->
          <HeroSection :left-image="mainImage"
                       :right-image="rightImage"
                       title="TULUM FESTIVAL | NYE 2025-2026"
                       subtitle="A shared goal in mind: Dance To Celebrate"></HeroSection>

          <section class="intro-section">

            <p class="text-center">

              From <strong>December to March</strong>, Tulum Mexico transforms into the global epicenter for electronic
              music.
              The world's best DJs, Producers and Travelers from all around converge in single location, with a shared
              goal in mind:
              <br>

              <strong style="font-size: 1.3rem;font-family: 'Oswald', sans-serif"><br>
                DANCE TO CELEBRATE</strong>

              <br>
              <strong>tulum.party</strong>

            </p>

            <p>Thrill-seekers and partiers come to Tulum mainly in the winter months looking for a warm place to have fun and see the beginning of the year.
              This is the time when the big festivals and immense parties go down , so it's no surprise that every year this season becomes the party season.

              If you've never come to Tulum, you should try it on New Year's Eve , and if you've finally pulled the trigger, we want to make sure you know what to do here once you get here
            </p>

          </section>

          <section class="text-center">
            <h2>Tulum, Mexico.</h2>
            <h3 class="text-center" style="margin-top: -30px">The Tribe Calls</h3>

            <MiniCarrousel :captions="this.topVenues.map(x => x.name)"
                           :photos="this.topVenues.map(x => x.image)"></MiniCarrousel>


            <hr class="section-divider">
            <a href="/brands"><strong>World-class production brands</strong></a> and <a href="/tulum-clubs"><strong>premier
            night clubs</strong></a> & <a href="/tulum-beach-clubs">beach clubs</a>, together with an <a
            href="/tulum-dj-schedule"><strong>elite roster of artists</strong></a>, deliver a truly unique experience.
          </section>


          <!-- Highlight Card Section -->
          <section class="highlight-card-section card">
            <h2>Tulum Through the Years: <br>A Video Journey

            </h2>
            <p class="text-center">
              <strong>Tulum's remarkable evolution has been captured on video</strong>, and we've collected the archives
              that tell the story: The sets that shook the jungle. The <strong>moments that became legend.</strong>

            </p>
            <br>
            <HighLightCard />
            <p class="text-center">

              🍿 It's popcorn time.
            </p>
          </section>

          <!-- Main Event Line Section -->
          <section class="event-line-section">
            <div class=" text-center">
              <h2 class="text-center">High Season </h2>
              <div class="speech-bubble-container">

                <svg width="180" height="130" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <!-- Define the pattern for the white hatch lines -->
                    <pattern id="hatch" patternUnits="userSpaceOnUse" width="8" height="8">
                      <path d="M-2,10 l12,-12" stroke="white" stroke-width="1.5" />
                    </pattern>
                  </defs>

                  <!-- The main speech bubble shape -->
                  <path
                    d="M 20 10 C 10 10, 10 20, 10 30 L 10 90 C 10 100, 20 100, 30 100 L 50 100 L 40 130 L 70 100 L 170 100 C 180 100, 190 100, 190 90 L 190 30 C 190 20, 180 10, 170 10 Z"
                    fill="url(#hatch)"
                    stroke="white"
                    stroke-width="3"
                  />
                </svg>
                <img style="margin-top: -1px;"
                     v-lazy="darthDancer">
                <h3>What? When? Where? </h3>

              </div>

              <p>
                The season is defined by a <strong>full spectrum of festivities</strong>. From <a
                href="/brands/zamna-tulum"><strong>large-scale festivals</strong></a> to <strong>intimate and
                exclusive DJ sets</strong>, the vibrant energy is felt in every corner of Tulum.
              </p>

              <p>
                The celebration continues with <a href="/tulum-beach-clubs">festive brunch & dinners</a>, and <a href="/tulum-clubs">exclusive club nights</a>, all soundtracked by world-class
                music. In Tulum, <strong>every moment is an opportunity for celebration</strong>.
              </p>

              <p>
                <strong><a href="/tulum-party-mexico-event-calendar">Stay tuned</a></strong>, as the complete calendar of events will be revealed
                as the dates draw nearer.
              </p>

            </div>
          </section>

          <section class="card" style="background: linear-gradient(transparent, #534a29)">
            <!-- Grouped Event List -->

            <h2>Event Line</h2>

            <div class="search-box text-center centered">
              <input
                type="text"
                v-model="searchTerm"
                placeholder="Search by event, artist, or venue..."
              />
            </div>

            <div class="event-list-container">
              <div v-for="(eventsOnDay, date) in filteredAndGroupedEvents" :key="date">
                <h3 class="sticky-date-header">
                  <span>{{ formatDateHeader(date) }}</span>
                </h3>
                <div class="day-events">
                  <EventCard
                    v-for="(event, idx) in eventsOnDay"
                    :key="event.slug"
                    :event="event"
                    :inverted="idx % 2 !== 0"
                  />
                </div>
              </div>
              <div v-if="Object.keys(filteredAndGroupedEvents).length === 0 && !this.$store.state.status.loading"
                   class="no-results">
                <p>No events match your search. Try another keyword!</p>
              </div>
            </div>
          </section>

          <hr class="section-divider">

          <div class="text-center">
            <p style="font-weight: bold">
              “Whenever you find yourself on the side of the majority,
              it is time to pause and reflect.” -Mark Twain.
            </p>
            <hr>
            <a href="https://www.instagram.com/tulum.party/" style="padding: 30px">
              &nbsp;
              <img v-lazy="insta" height="30px" width="30px" alt="follow tulum party in instagram"/>&nbsp;Follow Us
            </a>
            <br>
            <br>
            <small>              Check our instagram stories for more
            </small>
          </div>



          <hr class="section-divider">


          <!-- ✅ NEW: Top Venues & Brands Section -->
          <section class="top-venues-section text-center">

            <h2>Iconic Venues & Brands of the High Season</h2>

            <hr class="section-divider">
            <p>
              <a href="/brands"><strong>World-class production brands</strong></a> and <a href="/tulum-clubs"><strong>premier
              night clubs</strong></a> & <a href="/tulum-beach-clubs">beach clubs</a>, together with an <a
              href="/artists"><strong>elite roster of artists</strong></a>, deliver a truly unique experience.
              <br><br>
              <a href="/key-players">Discover the key players</a> who collaborate to make Tulum the winter mecca for
              underground electronic music.
            </p>


            <div class="cards-grid">
              <div v-for="item in topVenues" :key="item.name" class="brand-card">
                <div class="card-image-container">

                <router-link :to="item.link" class="card-link">
                  <ResponsiveImage :image="item.image" :alt="item.name" class="card-image" />
                  <div class="card-image-overlay">
                    <h3 class="card-name">{{ item.name }}</h3>
                    <p class="card-legend">{{ item.text }}</p>
                  </div>
                </router-link>
                </div>

              </div>
            </div>

            <hr class="section-divider">

            <!-- ✅ NEW: Tulum NYE Reservations CTA Section -->
            <section class="reserve-cta-section">
              <div class="cta-card">
                <!--                <img :src="astroImg" alt="Tulum Party Concierge" class="cta-image"/>-->
                <div class="cta-content">
                  <h2>Secure Your VIP Experience for Tulum NYE</h2>
                  <p>
                    Don't see a specific table reservation link? No problem. Our concierge team has access to every
                    major event and venue for the high season.
                    <br>
                    Let us handle the details for any party you want to
                    attend.
                  </p>

                  <br>

                  <RsvpViaDialog
                    :club-config="this.rsvpConfig"
                    mailAddress="gaby@tulum.party"
                    message="TULUM NYE_INFO:%20%0a-------%0a"
                    text="TALK TO US"
                    footer="NO EXTRA FEE"
                    legend="Settle In, Chill Out, We've Got Your Plans Covered."

                  ></RsvpViaDialog>
                  <hr>
                  <small class="cta-footer-text">We operate from 9AM - 10PM / Answer within 15 mins | NO EXTRA
                    FEE</small>
                </div>
              </div>
            </section>
            <hr class="section-divider">

            <h3>Pro Tips & Red Flags: Navigating NYE Like an Insider</h3>
            <div class="dos-donts-columns">
              <div class="column card gradient-card-dos">
                <h3><span class="emoji">⚡</span> DO's</h3>
                <ul>
                  <li><strong>Book Early:</strong> The best events sell out far in advance. Secure your tickets and
                    tables by early December at the absolute latest to avoid disappointment.
                  </li>
                  <li><strong>Buy from Official Sources:</strong> Only purchase from official platforms like Resident
                    Advisor (RA), Dice, or the venue's official website.
                  </li>
                  <li><strong>Look for All-Inclusive Packages:</strong> Reputable beach clubs like PPP and Bagatelle
                    offer premium dinner + party packages that provide the best value and experience.
                  </li>
                </ul>
              </div>
              <div class="column card gradient-card-donts">
                <h3><span class="emoji">⚠️</span> DONT'S</h3>
                <ul>
                  <li><strong>Avoid Unofficial Promoters:</strong> <strong>NEVER</strong> buy tickets from someone on
                    the street or via a random WhatsApp message. Fake tickets are common.
                  </li>
                  <li><strong>Beware of Vague "Open Bar" Promises:</strong> A cheap open bar deal often means long lines
                    and low-quality liquor. A reputable venue's package will be priced accordingly.
                  </li>
                  <li><strong>Don't Wait Until the Last Minute:</strong> Last-minute tickets from resellers are often
                    fake or astronomically priced. Plan ahead!
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </section>


        <!-- Sidebar Column -->
        <aside class="col-lg-4 col-sm-12">
          <div class="sidebar-sticky">
            <!-- Reservations Card -->
            <section class="cta-section card">
              <img v-lazy="astroImg + '?h=100'" height="100px" width="100px" alt="Info & Support" />
              <h3>Need Help Planning Your NYE Experience?</h3>
              <p>Your single source for all events & clubs needs. From tickets to VIP tables, our concierge team is here
                to help you craft the perfect high-season adventure.</p>
              <RsvpViaDialog
                text="INFO & RSVP"
                legend="<p>NYE 2026 Information & Reservations</p>"
              />
            </section>

            <!-- SmartMenu with other content -->
            <SmartMenu :links="links" :logo="astroImg" top-section-name="TALK TO US" cta-text="DROP US A LINE">
              <p>All Clubs & Events <br />Information & Reservations</p>
            </SmartMenu>

            <!-- Featured Brands Section -->
            <section class="featured-brands-section card">
              <h2>Featuring World-Class Production Brands</h2>
              <BrandCollection />
            </section>
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { eventDateMixin } from '@/common/eventDateMixin';
import EventCard from '../../components/EventCard/EventCard';
import BrandCollection from '@/components/Cards/BrandCollection';
import SmartMenu from '@/components/SmartMenu/SmartMenu';
import RsvpViaDialog from '@/components/Reservations/RsvpViaDialog';
import HighLightCard from '@/components/Cards/HighLightCard';
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';
import HeroSection from '@/components/HeroSection';
import MiniCarrousel from '@/components/MiniCarrousel';

export default {
  name: 'TulumNYE',
  mixins: [eventDateMixin],
  props: ['slug'],
  components: {
    MiniCarrousel,
    HeroSection,
    RsvpViaDialog,
    SmartMenu,
    EventCard,
    BrandCollection,
    HighLightCard,
    ResponsiveImage
  },
  metaInfo() {
    return {
      title: 'Tulum NYE 2025/2026 · New Year Festival · Event Line',
      link: [{ rel: 'canonical', href: 'https://www.tulum.party/tulum-new-year-festival-2025' }],
      meta: [
        {
          name: 'description',
          content: `The official event line for Tulum's NYE 2025-2026 high season. Find tickets, tables, and information for all major festivals and parties.`
        },
        {
          name: 'keywords',
          content: `Tulum NYE 2026, Tulum New Year Festival, Zamna 2026, Afterlife Tulum 2026, Tulum Rave, DJ Parties`
        },
        { property: 'og:title', content: `Tulum NYE 2025-2026. Tables, Tickets & Information` },
        { property: 'og:url', content: `https://www.tulum.party/tulum-new-year-festival-2025` },
        {
          property: 'og:image',
          content: 'https://imgix.cosmicjs.com/1ff4b960-d82b-11ef-bee4-3bb1d3c55332-zamna-tulum-2025-extra-9.jpg'
        }
      ]
    };
  },
  data() {
    return {
      searchTerm: '',
      mainImage: 'https://imgix.cosmicjs.com/1ff4b960-d82b-11ef-bee4-3bb1d3c55332-zamna-tulum-2025-extra-9.jpg',
      rightImage: 'https://imgix.cosmicjs.com/1ff4b960-d82b-11ef-bee4-3bb1d3c55332-zamna-tulum-2025-extra-9.jpg',
      astroImg: 'https://imgix.cosmicjs.com/6ed6b0f0-60cd-11ee-b3cd-9debaa756aee-image.png',
      visualBreakImage: 'https://imgix.cosmicjs.com/f0e84200-332e-11ef-a504-63e081e4680f-brand-day-zero-8.png',
      darthDancer: 'https://imgix.cosmicjs.com/ca320510-6c4e-11f0-841c-4bc5da578972-5B909252-9B70-4979-BB34-25748C969D5C.JPG?w=500&h=300&fit=clamp&auto=enhance',

      rsvpConfig: {
        name: 'NYE - DANCE TO CELEBRATE',
        color: '#be6a4d',
        primaryColor: '#1f1f1f',
        secondaryColor: '#be6a4d',
        logo: 'https://imgix.cosmicjs.com/16bea710-3e94-11ef-a504-63e081e4680f-small-drink.png'
      },
      insta:
        'https://imgix.cosmicjs.com/6d099b90-5c09-11ec-a8a3-53f360c99be6-instagram.png',
      topVenues: [
        {
          name: 'Zamna',
          image: 'https://imgix.cosmicjs.com/e84ef750-d82a-11ef-bee4-3bb1d3c55332-zamna-tulum-2025-3.jpg',
          link: '/brands/zamna-tulum',
          text: 'The undisputed king of large-scale jungle festivals, often hosting powerhouse brands like Afterlife for a pure, world-class musical journey.'
        },
        {
          name: 'Tehmplo',
          image: 'https://imgix.cosmicjs.com/0fe2bdc0-cc2c-11ef-8a63-eb57d6c77a36-tehmplo-main.jpg',
          link: '/brands/tehmplo-tulum'
        },
        {
          name: 'Vagalume',
          image: 'https://imgix.cosmicjs.com/323fb9e0-d4cf-11ee-9ce5-59949019255e-vagalume-7.jpg',
          link: '/tulum-clubs/vagalume-tulum',
          text: 'Known for its chic bohemian vibe and excellent music curation, Vagalume offers a fantastic balance of a sophisticated dinner and a spirited beach party.'
        },
        // {
        //   name: 'Papaya Playa Project',
        //   image: 'https://imgix.cosmicjs.com/827cb160-b345-11ef-bee4-3bb1d3c55332-club-papaya-playa-foto.jpg',
        //   link: '/tulum-clubs/papaya-playa',
        //   text: 'Famous for its legendary NYE parties, PPP perfectly blends high-end dining, artistic performances, and a lineup of top-tier electronic artists.'
        // },
        {
          name: 'Bagatelle Tulum',
          image: 'https://imgix.cosmicjs.com/02d9cc20-d82d-11ee-9ce5-59949019255e-Bagatelle-10.jpg',
          link: '/tulum-clubs/bagatelle-tulum',
          text: 'For a high-energy, "champagne-popping" celebration, Bagatelle delivers a luxurious dinner that seamlessly transforms into a wild, glamorous dance party.'
        },
        {
          name: 'Bonbonniere',
          image: 'https://imgix.cosmicjs.com/491a08e0-b45b-11ed-bce9-6ddb530a836d-Bonbonniere-Tulum.jpg',
          link: '/tulum-clubs/bonbonniere-tulum'
        },
        {
          name: 'DAY ZERO FESTIVAL',
          image: 'https://imgix.cosmicjs.com/fa964900-332e-11ef-a504-63e081e4680f-brand-day-zero-10.png',
          link: '/brands/day-zero-tulum',
          text: 'Damian Lazarus\'s mystical ceremony in the jungle. A powerful sense of community and incredible music until sunrise.'

        },
        {
          name: 'SET Underground',
          image: 'https://imgix.cosmicjs.com/bd804e90-b044-11ec-97bc-19d12908cbbe-set-underground-cover.jpg',
          link: '/brands/set-underground-tulum'
        }
      ]
    };
  },
  computed: {
    ...mapState({
      festival: state => state.festival,
      links: state => state.links || []
    }),
    allFestivalParties() {
      if (!this.festival || !this.festival.metadata || !this.festival.metadata.parties) {
        return [];
      }
      return [...this.festival.metadata.parties].sort((a, b) => {
        const dateA = new Date(`${a.metadata.date}T${a.metadata.start_time || '00:00'}`);
        const dateB = new Date(`${b.metadata.date}T${b.metadata.start_time || '00:00'}`);
        return dateA.getTime() - dateB.getTime();
      });
    },
    featuredParties() {
      return this.allFestivalParties.slice(0, 3);
    },
    filteredAndGroupedEvents() {
      let events = this.allFestivalParties;

      if (this.searchTerm) {
        const query = this.searchTerm.toLowerCase();
        events = events.filter(item =>
          item.slug.toLowerCase().includes(query) ||
          item.title.toLowerCase().includes(query) ||
          (item.metadata.lineup || '').toLowerCase().includes(query)
        );
      }

      return events.reduce((acc, event) => {
        const date = event.metadata.date;
        if (!acc[date]) acc[date] = [];
        acc[date].push(event);
        return acc;
      }, {});
    }
  },
  created() {
    this.$store.dispatch('getFestival', { slug: this.slug || 'tulum-new-year-festival-2025' });
    this.$store.dispatch('getLinks', { slug: 'tulum-new-year-festival' });
  },
  methods: {
    formatDateHeader(dateString) {
      const date = new Date(`${dateString}T12:00:00`);
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      }).format(date).toUpperCase();
    }
  }
};
</script>

<style scoped>
.nye-page-container {
  background-color: #1a1a1c;
  color: #f0f0f0;
}






.cta-card {
  background: linear-gradient(135deg, #2b2b2d, #252528);
  border: 1px solid #444;
  border-radius: 12px;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.cta-image {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
}

.cta-content {
  text-align: center;
}

.cta-content h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 1rem 0;
}



.page-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
}

section {
  margin-bottom: 4rem;
}

section h2 {
  text-align: center;
  font-weight: 700;
  margin-bottom: 2rem;
}

.highlight-card-section {
  background: linear-gradient(106deg, #3c585d, transparent);;
  padding: 20px;
}

.intro-section p {
  line-height: 1.8;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  margin-top: 30px
}


.event-line-section {
  padding: 2rem;
  border-radius: 12px;
  background: linear-gradient(106deg, #3c585d, transparent);
}


.search-box input {
  padding: 0.8rem;
  background-color: #3a3a3c;
  border: 1px solid #555;
  border-radius: 8px;
  color: #f0f0f0;
  font-size: 1rem;
  min-width: 300px;
}

.sticky-date-header {
  position: sticky;
  top: 0;
  background-color: #2a2a2d;
  padding: 0.75rem 1.5rem;
  z-index: 10;
  font-size: 1.2rem;
  font-weight: 700;
  border-bottom: 2px solid #d4af37;
  text-transform: uppercase;
  color: #fff;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.day-events {
  padding: 1.5rem 0;
}

.no-results {
  text-align: center;
  padding: 40px;
  font-size: 1.2em;
  color: #888;
}

.cta-section.card, .featured-brands-section.card {
  background: linear-gradient(135deg, #2b2b2d, #252528);
  text-align: center;
  padding: 2rem;
  margin-top: 2rem;
  border: 1px solid #444;
}

.cta-section h3 {
  font-size: 2rem;
  color: #fff;
  margin-top: 1rem;
}

.cta-section p {
  max-width: 600px;
  margin: 1rem auto 1.5rem auto;
  color: #ccc;
}

.sidebar-sticky {
  position: sticky;
  top: 20px;
}

.top-venues-section .venues-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.venue-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  height: 350px;
}

.venue-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.venue-card:hover .venue-image {
  transform: scale(1.05);
}

.venue-card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
  text-align: center;
}

.venue-card-overlay h3 {
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  text-shadow: 1px 1px 5px #000;
}


@media (max-width: 992px) {
  .sidebar-sticky {
    position: static;
  }
}
</style>



